import $ from 'jquery';
import { debounce, reduce } from 'lodash'

require('magnific-popup');

let $caseStudy, $caseStudyGallery, children

function setHeights() {
  if (! $caseStudy) {
    $caseStudy = $('.CaseStudy');
    children = $caseStudy.children('.row').get()
  }

  if (! $caseStudyGallery) {
    $caseStudyGallery = $('.CaseStudy__gallery');
  }

  let contentHeight = 0
  let max = 'auto'

  if ($window.width() >= 1100) {
    contentHeight = reduce(children, function(sum, item) {
      return sum + $(item).outerHeight();
    }, 0);

    max = Math.max(contentHeight, $caseStudyGallery.outerHeight());
  } else {
    max = 'auto'
  }

  $caseStudy.css('height', max);
  $caseStudyGallery.css('height', max);
}

function init() {
  $('.CaseStudy__image').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    },
    mainClass: 'CaseStudyGalleryPopup',
    removalDelay: 500
  });
}

let $window = $(window)

$window.on('load', setHeights)
$window.on('resize', debounce(setHeights, 100))


document.addEventListener('DOMContentLoaded', init);
document.addEventListener('turbolinks:load', init);



/** WEBPACK FOOTER **
 ** ./assets/js/lib/gallery.js
 **/